import React from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { SupabaseLoginPage } from '../components/SupabaseLoginPage';
import { ROUTES } from '../routes';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Get pre-filled email from URL parameters (from checkout success)
  const prefilledEmail = searchParams.get('email') || '';

  const handleSuccess = () => {
    // Redirect to the page they were trying to access, or home
    const from = location.state?.from?.pathname || ROUTES.HOME;
    navigate(from, { replace: true });
  };

  const handleSwitchToSignup = () => {
    navigate(ROUTES.SIGNUP, { state: location.state });
  };

  return (
    <SupabaseLoginPage
      prefilledEmail={prefilledEmail}
      onSuccess={handleSuccess}
      onSwitchToSignup={handleSwitchToSignup}
    />
  );
};

export default LoginPage;
